import React, { useState } from "react";
import { Box, InputLabel, Typography, Button, InputAdornment, IconButton } from "@material-ui/core";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import * as yup from "yup";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

import RedirectModal from "Components/GlobalLandingPage/Modal";
import CustomButton from "Components/Commons/CustomButton/CustomButton";
import MobileHeader from "Components/Header/MobileHeader";

import UserAvatar from "../../../Assets/Images/LandingPage/user-avatar.png";
import { URL_SCHOOL_REGISTER, URL_SUBSCRIPTION, URL_TEACHER_LOGIN } from "Helpers/Paths";
import { Api, URL_FRGT_PWD } from "Helpers";
import { showToast } from "Redux/General/Actions";
import { URL_GLOBAL_LANDING_PAGE } from "Helpers";
import { ReactComponent as HeaderLogo } from "../../../Assets/Images/LandingPage/subjects-master-logo.svg";
import { ReactComponent as ButtonArrow } from "../../../Assets/Images/Button/btn_arrow.svg";
import { ReactComponent as FacebookIcon } from "../../../Assets/Images/Header/Facebook.svg";
import { ReactComponent as InstaIcon } from "../../../Assets/Images/Header/Instagram.svg";
import { ReactComponent as TiktokIcon } from "../../../Assets/Images/Header/TikTok.svg";
import { SOCIAL_MEDIA_LINKS } from 'Helpers';
import { EmailField, PasswordField, Input } from "./GLPCommonComponentStyle";
import '../../../Styles/typography.css';
import '../../../Styles/authentication.css';

function TeacherLoginPageModal(props) {
	const dispatch = useDispatch();
	const [values, setValues] = useState({
		password: "",
		showPassword: false,
	});

	const [loading, setLoading] = useState(false);
	const validationSchema = yup.object({
		email: yup.string().required("* Email is required").email("* Enter a valid email"),
		password: yup.string().required("* Please enter your password "),
	});

	const formik = useFormik({
		initialValues: {
			email: "",
			password: "",
		},
		validationSchema,
		onSubmit: async () => {
			try {
				const values = formik.values;
				setLoading(true);
				const response = await new Api().post("user/cms/cmsLogin", {
					data: {
						email: values.email,
						password: values.password,
					},
					returnError: true,
				});
				if (response.status === 200 || response.status === 201) {
					const data = response?.data;
					if (data?.length) {
						window.location.href = `${process.env.REACT_APP_CMS_URL}login?token=${data}`;
					}
					setLoading(false);
				} else {
					setLoading(false);
					dispatch(showToast("Invalid Credentials"));
				}
				setLoading(false);
			} catch (error) {
				setLoading(false);
			}
		},
	});

	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword });
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	// Portal login is for teachers/admins only.
	// Students log in via /login and never set isLoggedIn in this flow,
	// so we must NOT redirect any logged-in user to /dashboard from here.

	return (

		<div className="login-regi-wrapper">
			<div className="auth-wrap-left">
				<div className="auth_wrap_logo">
					<MobileHeader></MobileHeader>
					<Link to="/" className="desktop_logo_login">
						<HeaderLogo></HeaderLogo>
					</Link>
				</div>
				<div className="auth_wrap_left_in">
					<h1>Welcome to  <br /> <span className='redfont'>Subjects Master</span></h1>
					<p>Welcome back to the Subjects Master Teacher Portal! Here’s where you can easily create fun learning games, track your students’ progress, and access all the tools that make teaching a little easier and a lot more engaging.</p>
				</div>
			</div>
			<div className="auth_wrap_right">
				<div className="">
					<div className="menu_other_buttons">
						<div className='social_handles'>
							<ul>
								<li>
									<a href={SOCIAL_MEDIA_LINKS.FACEBOOK} target="_blank" rel="noopener noreferrer">
										<FacebookIcon />
									</a>
								</li>
								<li>
									<a href={SOCIAL_MEDIA_LINKS.INSTAGRAM} target="_blank" rel="noopener noreferrer">
										<InstaIcon />
									</a>
								</li>
								<li>
									<a href={SOCIAL_MEDIA_LINKS.TIKTOK} target="_blank" rel="noopener noreferrer">
										<TiktokIcon />
									</a>
								</li>
							</ul>
						</div>

						<div className='portal_login_link'>
							<Link to='/teacher/login'>Portal Login</Link>
						</div>
						<div className='logins_btn'>
							<Link to='/register' className='customs_btn'>Register <span><ButtonArrow /></span></Link>
						</div>
					</div>
				</div>
				<div className="auth_right_inner">
					<div className="auth_right_head">
						<h2>Teacher’s Portal Login</h2>
						<h4 className="redfont">Your Adventure in Learning Starts Here</h4>
					</div>
					<form onSubmit={formik.handleSubmit}>
						<Box className="content">
							<Box>
								<Box className="flex-column field_wrapper-parent">
									<Box className="flex-column field_wrapper">
										<Box component="Box" sx={{ display: "inline" }} className="text">
											<InputLabel className="text">Email address</InputLabel>
										</Box>

										<EmailField
											id="email"
											name="email"
											className="login"
											autoComplete="false"
											onBlur={formik.handleBlur}
											onChange={formik.handleChange}
											defaultValue={formik.values.email}
											placeholder="Email address"
											helpertext={formik.touched.email && formik.errors.email}
										/>
										<Box component="div" sx={{ display: "inline", height: "10px" }} className="validation-error text">
											{formik.touched.email && formik.errors.email ? formik.errors.email : ""}
										</Box>
									</Box>

									<Box className="flex-column field_wrapper">
										<Box component="div" sx={{ display: "inline" }} className="text">
											<InputLabel className="text">Password</InputLabel>
										</Box>

										<PasswordField
											placeholder="Enter password"
											name="password"
											key="password"
											className="login"
											value={formik.values.password}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											type={values.showPassword ? "text" : "password"}
											endAdornment={
												<InputAdornment position="end" name="password" key="password">
													<IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} className="paswword-icon">
														{values.showPassword ? <Visibility /> : <VisibilityOff />}
													</IconButton>
												</InputAdornment>
											}
										/>
										<Box component="div" sx={{ display: "inline", height: "10px" }} className="validation-error text">
											{formik.touched.password && formik.errors.password ? formik.errors.password : ""}
										</Box>
									</Box>
								</Box>

								<Box className="remember-me-parent">
									{/* <Box className="flex-center">
										<Checkbox className="checkbox" />
										<Typography className="remember-me-font">Remember me</Typography>
									</Box> */}

									<Box className="forgot-password-parent">
										<Typography className="forgot-password">
											<Link to={URL_FRGT_PWD}>Forgot Password?</Link>
										</Typography>
									</Box>
								</Box>
							</Box>
							<div className="login_btn_divs">
								<Box className="login-button-parent">
									{/* <Button className="button" type="submit" endIcon={loading ? <CircularProgress className="loader" /> : ""}>
										<Typography className="login-font">Login</Typography>
									</Button> */}
									<CustomButton
										text={loading ? "Loading..." : "Login"}
										className="button"
										type="submit"
										loading={loading}
									/>
								</Box>

								<Box className="model-footer ac_info_foter">
									<Typography className="font dose-not-have-account-font">Don't have an account yet?</Typography>
									<Typography className="font register-as-school-font">
										<Link to={URL_SCHOOL_REGISTER}>Register as a school</Link>
									</Typography>
								</Box>
							</div>
						</Box>
					</form>
				</div>
			</div>
		</div>


	);
}

function SchoolRegisterPageModal(props) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const ssocode = location?.state?.ssocode;

	const subscriptionDetails = props?.subscriptionDetails || {};

	const [imageObj, setImageObj] = useState(null);
	const [uploadImage, setUploadImage] = useState("");
	// const [pageNumber, setPageNumber] = useState(1);

	const handleImage = (e) => {
		if (e?.target?.files[0]) {
			let fileObj = e.target.files[0];
			setImageObj(fileObj);
			if (fileObj) {
				setUploadImage(URL.createObjectURL(fileObj));
				setImageObj(fileObj);
			}
		} else {
			setUploadImage(null);
		}
	};

	// const [loading, setLoading] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [values, setValues] = useState({
		password: "",
		showPassword: false,
	});

	const phoneRegExp = new RegExp(/^[0-9]+$/);

	const validationSchema = yup.object({
		schoolName: yup.string("").trim().required("* School name is required"),
		email: yup.string("").email("* Enter a valid email").required("* Email is required"),
		password: yup.string("").trim().required("* Please enter your password").min(6, "* Password must be atleast 6 length"),
		address: yup.string("").trim().required("* Address is required"),
		phoneNumber: yup.string("").required("* Phone Number is required").matches(phoneRegExp, "* Phone number is not valid"),
	});

	const formik = useFormik({
		initialValues: {
			schoolName: location?.state?.schoolName || "",
			email: "",
			password: "",
			address: "",
			phoneNumber: "",
			isLinkedWithClassLink: false,
		},
		validationSchema,
		onSubmit: async (values) => {
			try {
				const bodyFormData = new FormData();

				const subscriptionList = Object.keys(subscriptionDetails);

				const payloadData = {
					schoolName: values?.schoolName,
					address: values?.address,
					email: values?.email,
					password: values?.password,
					phoneNumber: values?.phoneNumber,
					isLinkedWithClassLink: values?.isLinkedWithClassLink,
				};

				if (ssocode) {
					payloadData["isLinkedWithClassLink"] = true;
				}

				if (subscriptionList && subscriptionList.length) {
					payloadData.subscriptionRequestDto = { ...subscriptionDetails };
				}

				bodyFormData.append(
					"addSchoolRequestDTO",
					new Blob([JSON.stringify(payloadData)], {
						type: "application/json",
					})
				);

				if (uploadImage.length > 0) {
					bodyFormData.append("schoolProfilePic", imageObj);
				}

				// setLoading(true);
				if (ssocode || values?.isLinkedWithClassLink) setIsLoading(true);

				const response = await new Api().post("school", { data: bodyFormData, returnError: true });

				if (response.status === 200 || response.status === 201) {
					dispatch(showToast("Please verify your email"));
					if (ssocode || values?.isLinkedWithClassLink) {
						navigate(URL_SUBSCRIPTION, { state: { schoolId: response?.data?.schoolId, schoolSubscriptionDetails: response?.data?.schoolSubscriptionDetails } });
					} else {
						navigate(URL_GLOBAL_LANDING_PAGE);
					}
				}

				// setLoading(false);
			} catch (error) {
				setIsLoading(false);
				// setLoading(false);
			}
		},
	});

	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword });
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	// const handleNextButton = () => {
	// 	if (formik.dirty && !Object.keys(formik.errors).includes("schoolName") && !Object.keys(formik.errors).includes("email") && !Object.keys(formik.errors).includes("password")) {
	// 		setPageNumber(2);
	// 	}
	// };

	return (

		<div className="login-regi-wrapper regi_teachers">
			<div className="auth-wrap-left">
				<div className="auth_wrap_logo">
					<MobileHeader></MobileHeader>
					<Link to="/" className="desktop_logo_login">
						<HeaderLogo></HeaderLogo>
					</Link>
				</div>
				<div className="auth_wrap_left_in">
					<h1>Welcome to  <br /> <span className='redfont'>Subjects Master</span></h1>
					<p>Explore interactive games, quizzes, and activities that turn learning into an adventure. Discover new topics, challenge yourself, and test your knowledge, all while having fun!</p>
				</div>
			</div>
			<div className="auth_wrap_right">
				<div className="">
					<div className="menu_other_buttons">
						<div className='social_handles'>
							<ul>
								<li>
									<a href={SOCIAL_MEDIA_LINKS.FACEBOOK} target="_blank" rel="noopener noreferrer">
										<FacebookIcon />
									</a>
								</li>
								<li>
									<a href={SOCIAL_MEDIA_LINKS.INSTAGRAM} target="_blank" rel="noopener noreferrer">
										<InstaIcon />
									</a>
								</li>
								<li>
									<a href={SOCIAL_MEDIA_LINKS.TIKTOK} target="_blank" rel="noopener noreferrer">
										<TiktokIcon />
									</a>
								</li>
							</ul>
						</div>

						<div className='portal_login_link'>
							<Link to='/teacher/login'>Portal Login</Link>
						</div>
						<div className='logins_btn'>
							<Link to='/register' className='customs_btn'>Register <span><ButtonArrow /></span></Link>
						</div>
					</div>
				</div>
				<div className="auth_right_inner">
					<div className="auth_right_head">
						<h2>Register as a School</h2>
						<h4 className="redfont">Bring  Interactive Learning  to  Every  Classroom</h4>
					</div>
					<form onSubmit={formik.handleSubmit} className="form-data">
						<React.Fragment>
							{/* Upload Image */}
							<Box className="parent-container upload_img_main">
								<Box className="upload-image-parent">
									<img
										src={uploadImage ? uploadImage : values.fileName ? values.fileName : UserAvatar}
										alt="UploadImage"
										className="mtb-15 img"
									/>
								</Box>
								<Box>
									<Button className="upload-image" component="label">
										Upload image
										<input
											id="profilePicture"
											hidden
											type="file"
											accept="image/jpg,image/png,image/jpeg"
											onChange={(e) => handleImage(e)}
										/>
									</Button>
								</Box>
							</Box>

							{/* Form Fields */}
							<Box className="content">
								<Box className="flex-row-parent" style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>

									{/* School Name */}
									<Box className="flex-column field_wrapper" style={{ flex: "1 1 45%" }}>
										<InputLabel className="text">School Name</InputLabel>
										<Input
											id="schoolName"
											name="schoolName"
											onBlur={formik.handleBlur}
											onChange={formik.handleChange}
											value={formik.values.schoolName}
											placeholder="Enter School Name"
											className="school-register"
										/>
										<Box className="validation-error text">
											{formik.touched.schoolName && formik.errors.schoolName ? formik.errors.schoolName : ""}
										</Box>
									</Box>

									{/* School District */}
									{/* <Box className="flex-column field_wrapper" style={{ flex: "1 1 45%" }}>
										<InputLabel className="text">School District</InputLabel>
										<Input
											id="schoolDistrict"
											name="schoolDistrict"
											onBlur={formik.handleBlur}
											onChange={formik.handleChange}
											value={formik.values.schoolDistrict}
											placeholder="Enter School District"
											className="school-register"
										/>
										<Box className="validation-error text">
											{formik.touched.schoolDistrict && formik.errors.schoolDistrict ? formik.errors.schoolDistrict : ""}
										</Box>
									</Box> */}

									{/* Address */}
									<Box className="flex-column field_wrapper" style={{ flex: "1 1 45%" }}>
										<InputLabel className="text">Address</InputLabel>
										<Input
											id="address"
											name="address"
											value={formik.values.address}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											placeholder="Enter Address"
											className="school-register"
										/>
										<Box className="validation-error text">
											{formik.touched.address && formik.errors.address ? formik.errors.address : ""}
										</Box>
									</Box>

									{/* City */}
									{/* <Box className="flex-column field_wrapper" style={{ flex: "1 1 45%" }}>
										<InputLabel className="text">City</InputLabel>
										<Input
											id="city"
											name="city"
											value={formik.values.city}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											placeholder="Enter City"
											className="school-register"
										/>
										<Box className="validation-error text">
											{formik.touched.city && formik.errors.city ? formik.errors.city : ""}
										</Box>
									</Box> */}

									{/* State */}
									{/* <Box className="flex-column field_wrapper" style={{ flex: "1 1 45%" }}>
										<InputLabel className="text">State</InputLabel>
										<Input
											id="state"
											name="state"
											value={formik.values.state}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											placeholder="Enter State"
											className="school-register"
										/>
										<Box className="validation-error text">
											{formik.touched.state && formik.errors.state ? formik.errors.state : ""}
										</Box>
									</Box> */}

									{/* ZIP Code */}
									{/* <Box className="flex-column field_wrapper" style={{ flex: "1 1 45%" }}>
										<InputLabel className="text">ZIP Code</InputLabel>
										<Input
											id="zipCode"
											name="zipCode"
											value={formik.values.zipCode}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											placeholder="Enter ZIP Code"
											className="school-register"
										/>
										<Box className="validation-error text">
											{formik.touched.zipCode && formik.errors.zipCode ? formik.errors.zipCode : ""}
										</Box>
									</Box> */}

									{/* Email Address */}
									<Box className="flex-column field_wrapper" style={{ flex: "1 1 45%" }}>
										<InputLabel className="text">Email Address</InputLabel>
										<EmailField
											id="email"
											name="email"
											value={formik.values.email}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											placeholder="Enter Email Address"
											className="school-register"
										/>
										<Box className="validation-error text">
											{formik.touched.email && formik.errors.email ? formik.errors.email : ""}
										</Box>
									</Box>

									{/* Phone Number */}
									<Box className="flex-column field_wrapper" style={{ flex: "1 1 45%" }}>
										<InputLabel className="text">Phone Number</InputLabel>
										<Input
											id="phoneNumber"
											name="phoneNumber"
											type="number"
											value={formik.values.phoneNumber}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											placeholder="Enter Phone Number"
											className="school-register"
										/>
										<Box className="validation-error text">
											{formik.touched.phoneNumber && formik.errors.phoneNumber ? formik.errors.phoneNumber : ""}
										</Box>
									</Box>

									{/* Password */}
									<Box className="flex-column field_wrapper" style={{ flex: "1 1 45%" }}>
										<InputLabel className="text">Password</InputLabel>
										<PasswordField
											id="password"
											name="password"
											value={formik.values.password}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											type={values.showPassword ? "text" : "password"}
											placeholder="Enter Password"
											className="school-register"
											endAdornment={
												<InputAdornment position="end" name="password" key="password">
													<IconButton
														aria-label="toggle password visibility"
														onClick={handleClickShowPassword}
														onMouseDown={handleMouseDownPassword}
														className="paswword-icon"
													>
														{values.showPassword ? <Visibility /> : <VisibilityOff />}
													</IconButton>
												</InputAdornment>
											}
										/>
										<Box className="validation-error text">
											{formik.touched.password && formik.errors.password ? formik.errors.password : ""}
										</Box>
									</Box>
								</Box>
							</Box>

							{/* Submit Button */}

							<div className="button-container">
								<div className="next-button-parent">
									{/* <Button
										className=""
										type="submit"
										endIcon={loading ? <CircularProgress className="progress" /> : ""}
									>
										<Typography className="next-font">Register</Typography>
									</Button> */}

								</div>
							</div>
							<div className="login_btn_divs">
								<Box className="login-button-parent">
									<CustomButton
										text={isLoading ? "Loading..." : "Register"}
										className="button customs_btn button"
										type="submit"
										isLoading={isLoading}
									/>
								</Box>

								<Box className="model-footer ac_info_foter">
									<Typography className="font dose-not-have-account-font">Already have an account ?</Typography>
									<Typography className="font register-as-school-font">
										<Link to={URL_TEACHER_LOGIN}>Login</Link>
									</Typography>
								</Box>
							</div>
						</React.Fragment>
					</form>
					{isLoading && <RedirectModal open={isLoading} title={"Please Wait, While we are syncing your data with ClassLink"} />}

				</div>
			</div>
		</div >

	);
}

const GLPCommonComponentModal = (props) =>
	props.renderProps === "teacher-login" ? <TeacherLoginPageModal /> : <SchoolRegisterPageModal isSchoolRegister={true} subscriptionDetails={props?.subscriptionDetails} />;

export default GLPCommonComponentModal;
